import { IDiagnosticNotification } from 'utils/interfaces'
import WebsocketManager from 'utils/WebsocketManager'

/** Глобальный канал диагностических уведомлений, на который отправляется резолв. */
export const GLOBAL_WS_PATH = '/notifications/'

/** Счётчик request_id для исходящих WS-запросов. */
let resolveRequestId = 0

/**
 * Отправка резолва диагностического уведомления по WebSocket (глобальный канал).
 * Бэкенд (djangochannelsrestframework) ждёт поля action/request_id и
 * notification_id/button_id на верхнем уровне кадра — без вложенного data.
 */
export const resolveDiagnosticNotification = (
  notification: IDiagnosticNotification,
  buttonId: string
) => {
  resolveRequestId += 1
  const frame = {
    action: 'diagnostic_resolve',
    request_id: resolveRequestId,
    notification_id: notification.notification_id,
    button_id: buttonId,
  }
  WebsocketManager.sendMessage(JSON.stringify(frame), GLOBAL_WS_PATH)
}